import { Grid } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { patientAccessTheme } from '@HomaHealth/ui-component-library/lib/theme/theme';
import { TextField } from '@HomaHealth/ui-component-library/lib/_AIQ-components';
import { SimpleSearch } from '@HomaHealth/ui-component-library/lib/_patient-access-components';
import axios from 'axios';
import { observer } from 'mobx-react';
import React, { useEffect, useState } from 'react';
import {
  getHealthProfileAccordionData,
  getPatientProfileAccordionData,
} from '../../core-utils/formatters/PatientDetailsPageFormatters';
import properties from '../../core-utils/properties';
import Loader from '../../_components/molecules/Loader';
import PatientDetailsTabs from '../../_components/molecules/PatientDetailsTabs';
import PatientDetailsSideContent, {
  HealthProfileAccordionData,
  PatientProfileAccordionData,
} from '../../_components/organisms/PatientDetailsSideContent';
import { AlertColor as MuiColor } from '@mui/material/Alert';
import Snackbar from '../../_components/atoms/Snackbar';
import componentConstants from '../../core-utils/messages/componentConstants';
import { scrollBarStyles } from '../../core-utils/messages/CommonConstants';
import { useNavigate, useLocation } from 'react-router-dom';
import {
  AllMemberClaims,
  CareGapData,
  // DDIScore,
  formatMemberClaimsForMedicalHistory,
  // IndividualRafScore,
  MemberClaims,
  HealthConditions,
  getTextWithToolTip,
  SubCareGroupObject,
} from '../../core-utils/helper-utils/riskPatientDetailsHelper';
import messages from '../../core-utils/messages';
import { useStores } from '../../stores';
import {
  decryptData,
  getDateFromMonthAndYear,
  getMonthInNumberFormat,
} from '../../core-utils/helper-utils/helper';
import { getMedicationAdherence } from './helper';
import { PLAN_DOCUMENTS_INTERNAL } from '../../core-utils/routes';
import EditDurationModal from '../../_components/molecules/EditDurationModal';

// constants
const hospitalVisitData = [
  ['Inpatient', 0],
  ['Outpatient', 0],
  ['Emergency', 0],
  ['Office Visit ', 0],
  ['Urgent Care', 0],
];
const enrollmentData = [
  ['Plan', ''],
  ['Effective Date', ''],
  ['Termination Date', ''],
];

const PatientDetails = observer(() => {
  const useStyles = makeStyles()({
    sideContentGridItem: {
      height: 'calc(100vh - 59px)',
      width: '346px',
      backgroundColor: patientAccessTheme.palette.status.white,
      boxSizing: 'border-box',
      border: ` solid ${patientAccessTheme.palette.grey[300]}`,
      borderWidth: '1px 1px 1px 0px',
      overflowY: 'auto',
      ...scrollBarStyles,
    },
    mainContentGridItem: {
      height: 'calc(100vh - 59px)',
      width: 'calc(100% - 346px)',
      overflowY: 'auto',
      boxSizing: 'border-box',
      '&::-webkit-scrollbar': {
        width: '5px',
        borderRadius: '12px',
        backgroundColor: patientAccessTheme.palette.primary.light,
      },
      '&::-webkit-scrollbar-track': {
        background: patientAccessTheme.palette.grey[300],
        borderRadius: '12px',
      },
      '&::-webkit-scrollbar-thumb': {
        background: patientAccessTheme.palette.grey[500],
        borderRadius: '12px',
      },
      flexWrap: 'nowrap',
    },
  });
  const [startDate, setStartDate] = useState<string>('');
  const [endDate, setEndDate] = useState<string>('');

  const [patient, setPatient] = useState<any>({
    contact: '',
    address: '',
    group_id: '',
    patient_id: '',
    member_id: '',
    group_name: '',
    patient_name: '',
  });

  const loginPageStore = useStores().loginPageStore;

  const getPlanStartDate = () => {
    const startMonth =
      employerGroupStore?.employerGroupResponseData?.plan_start_month;
    const startYear =
      employerGroupStore?.employerGroupResponseData?.recent_plan_year;
    const startDate =
      startYear + '-' + getMonthInNumberFormat(startMonth) + '-01';
    return startDate;
  };
  const getPlanEndDate = () => {
    const endMonth =
      employerGroupStore?.employerGroupResponseData?.plan_end_month;
    const endYear =
      employerGroupStore?.employerGroupResponseData?.recent_plan_year;
    const endDate = endYear + '-' + getMonthInNumberFormat(endMonth) + '-01';
    return endDate;
  };

  const pageConstants = componentConstants.PAGES.PATIENT_DETAILS_PAGE;

  const { classes } = useStyles();
  const navigate = useNavigate();
  const location = useLocation();
  const memberSummaryStore = useStores().memberSummaryStore;
  const memberId: any = location.state || {};
  const MEMBER_ID = memberId.memberId || memberSummaryStore.memberIds?.[0];
  const PATIENT_ID = memberId.patientId || '';
  const employerGroupStore = useStores().employerGroupStore;
  const handleOpenSnackBar = (
    message: string,
    severity: MuiColor,
    duration: number | null,
  ) => {
    setSnackbarState({
      open: true,
      message: message,
      severity: severity,
      duration: duration,
    });
  };

  const handleCloseSnackBar = (
    event?: React.SyntheticEvent,
    reason?: string,
  ) => {
    if (reason === 'clickaway') {
      return;
    }
    setSnackbarState({
      open: false,
      message: '',
      severity: undefined,
      duration: null,
    });
  };

  const handleOnClickPlan = async () => {
    navigate(PLAN_DOCUMENTS_INTERNAL, { state: { tabIndex: 1 } });
  };

  // states
  const [loading, setLoading] = useState<boolean>(true);

  const [snackbarState, setSnackbarState] = React.useState<{
    open: boolean;
    message: string;
    severity: MuiColor | undefined;
    duration: null | number;
  }>({
    open: false,
    message: '',
    severity: undefined,
    duration: null,
  });

  const [
    patientProfileAccordionData,
    setPatientProfileAccordionData,
  ] = useState<PatientProfileAccordionData>({
    values: ['-', '-', '-'],
    hospitalVisitData: hospitalVisitData,
    totalCostData: [['-', '-']],
    recentVisitData: [['-', '-']],
    memberRelationShipData: '',
    enrollmentData: enrollmentData,
  });

  // const [individualRafScore, setIndividualRafScore] = useState<
  //   IndividualRafScore[]
  // >();

  // const [ddiScore, setddiScore] = useState<DDIScore[]>();
  const [medicationAdherence, setMedicationAdherence] = useState<any[]>([]);
  const [activeMedications, setActiveMedications] = useState<any[]>([]);
  const [careGapData, setCareGapData] = useState<CareGapData[]>();
  const [allMemberClaimData, setAllMemberClaimData] = useState<
    AllMemberClaims[]
  >([]);
  const [chronicConditions, setChronicConditions] = useState<
    HealthConditions[]
  >();
  const [inherentConditions, setInherentConditions] = useState<
    HealthConditions[]
  >();
  const [referrals, setReferrals] = useState<string[]>([]);
  const [typeOfTrigger, setTypeOfTrigger] = useState<string[]>([]);

  const [
    healthProfileAccordionData,
    setHealthProfileAccordionData,
  ] = useState<HealthProfileAccordionData>({
    currentCondition: '-',
    latentRiskData: [['-', '-']],
  });

  const [increment, setIncrement] = useState(0);
  const [showLoadMore, setShowLoadMore] = useState(true);

  // api calls
  const getMemberClaims = async () => {
    if (increment >= 1) {
      handleOpenSnackBar(messages.LOADING_NEXT_20_RECORDS, 'success', 2000);
    }
    const {
      eg_nid,
      start_year,
      start_month,
      max_claim_date,
    } = employerGroupStore?.employerGroupResponseData;
    return await axios
      .post(
        properties.aiqBaseUrl +
          properties.membersBaseUrl +
          properties.memberDetails,
        {
          eg_nid: eg_nid,
          startDate: getDateFromMonthAndYear(start_month, start_year),
          endDate: max_claim_date,
          member_unique_id: [MEMBER_ID],
          limit: 20,
          increment: increment,
          claim_id_list: [],
        },
      )
      .then((res) => {
        if (res?.status === 200) {
          const memberClaim: MemberClaims[] = res?.data?.data;
          if (memberClaim?.length < 20) {
            setShowLoadMore(false);
          }
          const element: AllMemberClaims = {
            memberId: '',
            claimData: [],
          };
          element.memberId = MEMBER_ID;
          element.claimData = memberClaim;
          allMemberClaimData.push({
            memberId: MEMBER_ID,
            claimData: memberClaim,
          });
          setAllMemberClaimData([...allMemberClaimData]);
        }
      })
      .catch((error) => {
        handleOpenSnackBar(
          error.response?.data?.error ?? messages.SOMETHING_WENT_WRONG,
          'error',
          8000,
        );
      });
  };

  const getPatientProfileData = async () => {
    const url =
      properties.aiqBaseUrl +
      properties.membersBaseUrl +
      properties.patientProfile;
    const requestBody = {
      eg_nid: employerGroupStore?.employerGroupResponseData?.eg_nid,
      member_unique_id: MEMBER_ID,
      memberIdentification: loginPageStore.memberIdentification,
    };

    await axios
      .post(url, requestBody)
      .then((response) => {
        setPatientProfileAccordionData(
          getPatientProfileAccordionData(
            response?.data?.data,
            MEMBER_ID,
            handleOnClickPlan,
          ),
        );
      })
      .catch((error) => {
        handleOpenSnackBar(
          error.response?.data?.error ?? messages.SOMETHING_WENT_WRONG,
          'error',
          8000,
        );
      });
  };

  const handleContactChange = async () => {
    await axios
      .post(
        properties.aiqBaseUrl +
          properties.patientsBaseUrl +
          properties.updateContact,
        {
          patient_id: PATIENT_ID,
          member_id: MEMBER_ID,
          contact: patient.contact,
          address: patient.address,
        },
      )
      .then((res) => {
        if (res?.status === 200) {
          handleOpenSnackBar('Contact & address saved.', 'success', 6000);
        }
      })
      .catch((error) =>
        handleOpenSnackBar(error.response?.data?.error, 'error', 6000),
      );
  };

  const requestBodyCareGap = {
    endDate: getPlanEndDate(),
    startDate: getPlanStartDate(),
    eg_nid: employerGroupStore?.employerGroupResponseData?.eg_nid,
    member_unique_id_list: [MEMBER_ID],
    max_claim_date:
      employerGroupStore?.employerGroupResponseData.max_claim_date,
  };
  const getCareQualityMeasures = async () => {
    await axios
      .post(
        properties.aiqBaseUrl +
          properties.memberSummaryBaseUrl +
          properties.careQualityMeasures,
        requestBodyCareGap,
      )
      .then((res) => {
        if (res?.status === 200) {
          setCareGapData(res?.data?.data);
        }
      })
      .catch((error) => {
        return error;
      });
  };

  const getHealthProfileData = async () => {
    const url =
      properties.aiqBaseUrl +
      properties.membersBaseUrl +
      properties.healthDetails;

    const requestBody = {
      eg_nid: employerGroupStore?.employerGroupResponseData?.eg_nid,
      member_unique_id: MEMBER_ID,
    };
    await axios
      .post(url, requestBody)
      .then((response) => {
        setHealthProfileAccordionData(
          getHealthProfileAccordionData(response?.data?.data),
        );
      })
      .catch((error) => {
        handleOpenSnackBar(
          error.response?.data?.error ?? messages.SOMETHING_WENT_WRONG,
          'error',
          8000,
        );
      });
  };
  const getChronicHealthConditions = async () => {
    const url =
      properties.aiqBaseUrl +
      properties.membersBaseUrl +
      properties.chronicConditions;
    const requestBody = {
      eg_nid: employerGroupStore?.employerGroupResponseData?.eg_nid,
      member_unique_id: MEMBER_ID,
    };
    await axios
      .post(url, requestBody)
      .then((response) => {
        setChronicConditions(response?.data?.data);
      })
      .catch((error) => {
        return error;
      });
  };
  const getInherentRiskConditions = async () => {
    const url =
      properties.aiqBaseUrl +
      properties.membersBaseUrl +
      properties.inherentConditions;
    const requestBody = {
      eg_nid: employerGroupStore?.employerGroupResponseData?.eg_nid,
      member_unique_id: MEMBER_ID,
    };
    await axios
      .post(url, requestBody)
      .then((response) => {
        setInherentConditions(response?.data?.data);
      })
      .catch((error) => {
        return error;
      });
  };
  const getActiveMedications = async () => {
    const url =
      properties.aiqBaseUrl +
      properties.membersBaseUrl +
      properties.activeMedications;
    const requestBody = {
      eg_nid: employerGroupStore?.employerGroupResponseData?.eg_nid,
      member_unique_id: MEMBER_ID,
      max_claim_date:
        employerGroupStore?.employerGroupResponseData?.max_claim_date,
    };
    await axios
      .post(url, requestBody)
      .then((response) => {
        if (response?.status === 200) {
          const data = response.data?.data;

          const table: any[] = [];
          if (Array.isArray(data)) {
            data?.forEach(async (item: any) => {
              const condition: any = [];
              condition.push(
                item.medication_name?.length > 20
                  ? getTextWithToolTip(item.medication_name, 20)
                  : item.medication_name,
              );
              condition.push(item.fill_date);
              condition.push(getTextWithToolTip(item.theraputic_class, 20));

              table.push(condition);
            });
          }
          setActiveMedications(table);
        }
      })
      .catch((error) => {
        return error;
      });
  };
  const getPatientDetails = async () => {
    const url =
      properties.aiqBaseUrl +
      properties.patientsBaseUrl +
      properties.getPatientByMemberId;
    const requestBody = {
      member_id: MEMBER_ID,
      eg_nid: employerGroupStore?.employerGroupResponseData?.eg_nid,
    };
    await axios
      .post(url, requestBody)
      .then((response) => {
        const data = response?.data?.data?.[0];
        setPatient({
          contact: data.contact || '',
          address: data.address || '',
          group_id: data.group_id._id,
          patient_id: data._id,
          member_id: data.member_id,
          group_name: data.group_id.group_name,
          patient_name:
            data.created_by === 'system' ? decryptData(data.name) : data.name,
        });
      })
      .catch((error) => {
        return error;
      });
  };

  const getTypeOfTriggers = async () => {
    const url =
      properties.aiqBaseUrl +
      properties.dynamicFieldsBaseUrl +
      properties.getDynamicFields;
    const requestBody = {
      field: 'type_of_triggers',
    };
    await axios
      .post(url, requestBody)
      .then((response) => {
        setTypeOfTrigger(response?.data?.data);
      })
      .catch((error) => {
        return error;
      });
  };
  const getReferrals = async () => {
    const url =
      properties.aiqBaseUrl +
      properties.dynamicFieldsBaseUrl +
      properties.getDynamicFields;
    const requestBody = {
      field: 'referrals',
    };
    await axios
      .post(url, requestBody)
      .then((response) => {
        setReferrals(response?.data?.data);
      })
      .catch((error) => {
        return error;
      });
  };

  const getPageData = async () => {
    setLoading(true);
    if (startDate !== '' && endDate !== '') {
      try {
        await Promise.all([
          getPatientProfileData(),
          getHealthProfileData(),
          getCareQualityMeasures(),
          getMemberClaims(),
          getChronicHealthConditions(),
          getInherentRiskConditions(),
          getActiveMedications(),
          // getIndividualRafScore(),
          // getDDIScore(),
          getMedicationAdherence(
            {
              eg_nid: employerGroupStore?.employerGroupResponseData?.eg_nid,
              member_unique_id: MEMBER_ID,
            },
            setMedicationAdherence,
            handleOpenSnackBar,
          ),
          getPatientDetails(),
          getTypeOfTriggers(),
          loginPageStore.isCareNavigator ? getReferrals() : Promise.resolve(),
        ]);
      } catch {
      } finally {
        setLoading(false);
      }
    } else {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (startDate !== '' && endDate !== '') {
      getPageData();
    }
  }, [startDate, endDate, MEMBER_ID]);

  useEffect(() => {
    const startDateVal = getDateFromMonthAndYear(
      employerGroupStore.employerGroupResponseData.start_month,
      employerGroupStore.employerGroupResponseData.recent_plan_year,
    );
    const endDateVal = getDateFromMonthAndYear(
      employerGroupStore.employerGroupResponseData.end_month,
      employerGroupStore.employerGroupResponseData.end_year,
      true,
    );

    setStartDate(startDateVal || '');
    setEndDate(endDateVal || '');
  }, [employerGroupStore.employerGroupResponseData]);

  useEffect(() => {
    if (increment >= 1) {
      const element = document.getElementById('search-tabs');
      if (element) {
        element.scrollTop = element.scrollHeight;
      }
      getMemberClaims();
    }
  }, [increment]);

  // const getRafScoreandRisk = () => {
  //   if (
  //     individualRafScore !== undefined &&
  //     individualRafScore?.[0] !== undefined
  //   ) {
  //     return [
  //       [
  //         individualRafScore?.[0].raf_score === undefined
  //           ? ' '
  //           : individualRafScore?.[0].raf_score,
  //       ],
  //       // [
  //       //   individualRafScore?.[0].risk_level === undefined
  //       //     ? ''
  //       //     : individualRafScore?.[0].risk_level,
  //       // ],
  //       [''],
  //     ];
  //   } else {
  //     return [[''], ['']];
  //   }
  // };
  // const getPolyPharmaInteractionValues = () => {
  //   if (ddiScore !== undefined && ddiScore?.[0] !== undefined) {
  //     return [
  //       [ddiScore?.[0]?.class === undefined ? '' : ddiScore?.[0]?.class, ''],
  //     ];
  //   }
  //   return [[''], ['']];
  // };

  const getCareGapsTabData = () => {
    const tempMap = new Map<string, SubCareGroupObject>();

    careGapData?.map((item) => {
      let chipText;
      let complied = 0;
      let notComplied = 0;
      if (item.measureMetCount === 1 && item.measureNotMetCount === 0) {
        chipText = 'Complied';
        complied++;
      } else if (item.measureMetCount === 0 && item.measureNotMetCount === 1) {
        chipText = 'Not Complied';
        notComplied++;
      } else {
        chipText = 'NA';
      }

      if (tempMap.get(item?.measureGroup)) {
        const subrowArrayItem = {
          title2: item.measure,
          chipText: chipText,
        };
        tempMap.get(item?.measureGroup)?.subCareGroup?.push(subrowArrayItem);
        if (chipText === 'Complied') {
          tempMap.get(item?.measureGroup)!.complied++;
        } else if (chipText === 'Not Complied') {
          tempMap.get(item?.measureGroup)!.notComplied++;
        }
      } else {
        const subrowArray = [];
        const subrowArrayItem = {
          title2: item.measure,
          chipText: chipText,
        };
        subrowArray.push(subrowArrayItem);
        tempMap.set(item?.measureGroup, {
          complied,
          notComplied,
          selfImposed: item?.selfImposed,
          subCareGroup: subrowArray,
        });
      }
    });
    const SystemRisk: any = {
      compliedCount: 0,
      notCompliedCount: 0,
      subCareGroup: [],
    };
    const SelfImposed: any = {
      compliedCount: 0,
      notCompliedCount: 0,
      subCareGroup: [],
    };

    tempMap.forEach((value, key) => {
      const t = {
        title: key,
        context: value.subCareGroup,
      };
      if (value.selfImposed) {
        SelfImposed.subCareGroup.push(t);
        SelfImposed.compliedCount += value.complied;
        SelfImposed.notCompliedCount += value.notComplied;
      } else {
        SystemRisk.subCareGroup.push(t);
        SystemRisk.compliedCount += value.complied;
        SystemRisk.notCompliedCount += value.notComplied;
      }
    });
    return {
      SelfImposed,
      SystemRisk,
    };
  };

  const getChronicHealthConditionsData = () => {
    const table: any[] = [];
    chronicConditions?.forEach(async (item) => {
      const condition: any = [];
      condition.push(getTextWithToolTip(item.disease_name, 20));
      condition.push(item.service_date);
      table.push(condition);
    });
    return table;
  };

  const getInherentRiskConditionsData = () => {
    const table: any[] = [];
    inherentConditions?.forEach(async (item) => {
      const condition: any = [];
      condition.push(getTextWithToolTip(item.disease_name, 20));
      condition.push(item.service_date);
      table.push(condition);
    });
    return table;
  };

  const handleMedicalHistoryDownArrow = () => {
    setIncrement((prevIncrement) => prevIncrement + 1);
  };

  const handleDateChange = () => {
    setStartDate(employerGroupStore?.selectedDuration?.startDate);
    setEndDate(employerGroupStore?.selectedDuration?.endDate);
  };

  const [loader] = useState<any>(<Loader />);
  return loading ? (
    loader
  ) : (
    <>
      <Grid container style={{ width: '100%' }}>
        <Grid className={classes.sideContentGridItem}>
          <PatientDetailsSideContent
            showContact={loginPageStore.isCareNavigator}
            patientState={[patient, setPatient]}
            handleContactChange={handleContactChange}
            memberId={MEMBER_ID}
            patientProfileAccordionData={patientProfileAccordionData}
            healthProfileAccordionData={healthProfileAccordionData}
          />
        </Grid>
        <Grid
          container
          className={classes.mainContentGridItem}
          id="search-tabs"
          sx={{
            flexDirection: 'column',
          }}
        >
          <Grid style={{ margin: '31px 0px 30px 34px' }}>
            <TextField
              placeholder={pageConstants.SEARCH_HISTORY}
              height={'40px'}
              width={'401px'}
              startAdornment={
                <SimpleSearch
                  height="20px"
                  width="20px"
                  stroke={patientAccessTheme.palette.text.lowemphasis}
                />
              }
              showStartAdornment={true}
            />
            <Grid style={{ display: 'none' }}>
              <EditDurationModal
                isYearGrid={false}
                handleDateChange={handleDateChange}
              />
            </Grid>
          </Grid>
          <Grid>
            <PatientDetailsTabs
              medicalHistoryTabData={formatMemberClaimsForMedicalHistory(
                allMemberClaimData,
                MEMBER_ID,
              )}
              careGapsTabData={getCareGapsTabData()}
              adherenceValues={medicationAdherence}
              activeMedications={activeMedications}
              // rafScoreValues={getRafScoreandRisk()}
              // polyPharmaInteractionValues={getPolyPharmaInteractionValues()}
              handleDownArrow={handleMedicalHistoryDownArrow}
              chronicHealthConditions={getChronicHealthConditionsData()}
              inherentRiskConditions={getInherentRiskConditionsData()}
              showLoadMore={showLoadMore}
              // patientId={PATIENT_ID}
              isCareNavigator={loginPageStore.isCareNavigator}
              typeOfTriggers={typeOfTrigger}
              referrals={referrals}
              patientData={patient}
            />
          </Grid>
        </Grid>
      </Grid>

      <Snackbar
        {...snackbarState}
        handleClose={handleCloseSnackBar}
        vertical="bottom"
        horizontal="right"
      />
    </>
  );
});

export default PatientDetails;
